/* global __TARGET__*/
import Reflux from 'reflux';
import { AppActions, PaymentActions } from 'actions';
import SteelCompass from 'services/SteelCompass';
import Config from 'Config';
import FacebookPixel from 'helpers/facebookPixel';

const inProduction = process.env.NODE_ENV === 'production';

const KlarnaStore = Reflux.createStore({
  listenables: [PaymentActions],
  data: {
    paymentComplete: false,
    error: null,
    method: null
  },
  getInitialState() {
    return this.data;
  },
  init() {},
  change(props) {
    this.data = {
      ...this.data,
      ...props
    };
    this.trigger(this.data);
  },
  start(cart, providerId, storeId, discountCode, token, evidence, address) {
    this.data = {
      ...this.data,
      paymentComplete: false,
      error: null,
      loading: true
    };
    this.trigger(this.data);
    SteelCompass.request('payment', 'start', {
      address,
      evidence,
      cart,
      providerId,
      storeId,
      discountCode,
      token
    }).then(
      data => {
        if (data) {
          PaymentActions.paymentCompleted(data);
        } else {
          this.error();
        }
      },
      error => {
        this.error(error);
      }
    );
  },
  error(error) {
    this.data = {
      ...this.data,
      loading: false,
      error,
      paymentComplete: false
    };
    this.trigger(this.data);
    AppActions.genericError(error);
  },
  paymentCompleted(data) {
    this.data = {
      ...this.data,
      paymentComplete: true,
      loading: false
    };
    const options = {
      autoConfig: true,
      debug: false
    };
    const facebookPixelId =
      inProduction && data.js ? data.js.pixel : Config.facebookPixelId;
    FacebookPixel.init(facebookPixelId, null, options);
    FacebookPixel.track('Purchase', {
      currency: data.currency,
      value: data.price
    });
    this.trigger(this.data);
  },
  paymentStarted(data) {}
});

export default KlarnaStore;



// WEBPACK FOOTER //
// ./src/js/stores/Payment.js